export default __webpack_public_path__ + "static/media/Megosu---Lukas-Bazle---Moooi---GIF.80e674f6.png";